import { createContext } from 'react';

import ComponentType from '../../types/Component';
import StylesType from '../../types/Styles';

export const StylesProviderContext = createContext({
	primaryColor: '#eb7353',
	fontColor: 'var(--theme-colors-100)',
	bgColor: 'var(--theme-colors-100)',
	isWhiteBackground: true,
} as StylesType);

const whiteBackground = ['#fff', '#ffffff', 'rgb(255, 255, 255)', 'rgba(255, 255, 255, 1)'];

const StylesProvider: ComponentType<{ initialState: StylesType }> = ({
	initialState,
	children,
}) => {
	const styles: StylesType = {
		...initialState,
		isWhiteBackground:
			initialState?.background?.type === 'color' &&
			whiteBackground.includes(
				(initialState?.background?.options?.backgroundColor ?? initialState?.bgColor).toLowerCase()
			),
	};

	return <StylesProviderContext.Provider value={styles}>{children}</StylesProviderContext.Provider>;
};

export default StylesProvider;
